var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2181 32.7819C24.9342 32.7819 31.9999 25.7161 31.9999 17.0001C31.9999 8.28402 24.9342 1.21826 16.2181 1.21826C7.50204 1.21826 0.436279 8.28402 0.436279 17.0001C0.436279 25.7161 7.50204 32.7819 16.2181 32.7819Z",
    stroke: "#251F2C",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67261 11.5454H26.7635",
    stroke: "#251F2C",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67261 17.3638H26.7635",
    stroke: "#251F2C",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67261 23.1821H26.7635",
    stroke: "#251F2C",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8544 13.3636C13.0594 13.3636 14.0362 12.3868 14.0362 11.1818C14.0362 9.97683 13.0594 9 11.8544 9C10.6494 9 9.67261 9.97683 9.67261 11.1818C9.67261 12.3868 10.6494 13.3636 11.8544 13.3636Z",
    fill: "#251F2C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0363 19.182C23.2413 19.182 24.2181 18.2052 24.2181 17.0002C24.2181 15.7952 23.2413 14.8184 22.0363 14.8184C20.8313 14.8184 19.8545 15.7952 19.8545 17.0002C19.8545 18.2052 20.8313 19.182 22.0363 19.182Z",
    fill: "#251F2C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0363 24.9999C15.2413 24.9999 16.2181 24.023 16.2181 22.818C16.2181 21.6131 15.2413 20.6362 14.0363 20.6362C12.8313 20.6362 11.8545 21.6131 11.8545 22.818C11.8545 24.023 12.8313 24.9999 14.0363 24.9999Z",
    fill: "#251F2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6def29d1c05d11488c50dc610b119aed.svg";
export { ForwardRef as ReactComponent };